$(document).ready(function () {
  $(".slider_image-main").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024, // Adjust for screens larger than 1024px
        settings: {
          slidesToShow: 2, // Show 3 slides on larger screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // Adjust for screens smaller than 480px
        settings: {
          slidesToShow: 1, // Show 1 slide on small screens
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".collection_slick_slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrow: true,
          infinite: true,
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
    ],
  });

  var $arrows = $(
    ".collection_slick_slider .slick-prev,.collection_slick_slider .slick-next"
  );
  var $arrowWrapper = $('<div class="custom-arrows"></div>');

  $arrowWrapper.append($arrows);
  $(".collection_slick_slider").append($arrowWrapper);
});
